import { createSelector } from 'reselect'
import logoutStatus from '../constants/logout-status'
import { ON_LOGOUT_OKTA,
    ON_LOGOUT_OKTA_ERROR,
    ON_LOGOUT_OKTA_SUCCESS,
    ON_LOGOUT_OAG,
    ON_LOGOUT_OAG_ERROR,
    ON_LOGOUT_OAG_SUCCESS } from '../constants/application'


export const initialState = {
    logoutStatusOAG: logoutStatus.DEFAULT,
    logoutStatusOkta: logoutStatus.DEFAULT
}

// Selectors
const selectRequestData = state => state.application

const selectStateFor = key => createSelector(
    selectRequestData,
    (request = {}) => request[key]
)

export const selectLogoutStatusOkta = selectStateFor('logoutStatusOkta')
export const selectLogoutStatusOAG = selectStateFor('logoutStatusOAG')

export default function application(state = initialState, action) {
    switch (action.type) {
        case ON_LOGOUT_OKTA:
            return {
                ...state,
                logoutStatusOkta: logoutStatus.PENDING
            }
        case ON_LOGOUT_OKTA_ERROR:
            return {
                ...state,
                logoutStatusOkta: logoutStatus.ERROR
            }
        case ON_LOGOUT_OKTA_SUCCESS:
            return {
                ...state,
                logoutStatusOkta: logoutStatus.SUCCESS
            }
        case ON_LOGOUT_OAG:
            return {
                ...state,
                logoutStatusOAG: logoutStatus.PENDING
            }
        case ON_LOGOUT_OAG_ERROR:
            return {
                ...state,
                logoutStatusOAG: logoutStatus.ERROR
            }
        case ON_LOGOUT_OAG_SUCCESS:
            return {
                ...state,
                logoutStatusOAG: logoutStatus.SUCCESS
            }
        default:
            return state
    }
}
